export default __webpack_public_path__ + "static/media/smartphone.0a67be47.svg";